
import { createRoot } from 'react-dom/client';
const isAppsPlanRoute = (pathname: string) =>
  pathname === '/' || pathname === '/privacy' || pathname === '/terms'
  || pathname === '/newsletter/confirm' || pathname === '/newsletter/unsubscribe';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

const renderApp = async () => {
  const { default: App } = isAppsPlanRoute(window.location.pathname)
    ? await import('./AppsPlanApp')
    : await import('./App');
  createRoot(rootElement).render(<App />);
};

if (window.location.protocol === 'file:') {
  void import('@ionic/pwa-elements/loader')
    .then(({ defineCustomElements }) => defineCustomElements(window))
    .finally(() => void renderApp());
} else {
  void renderApp();
}
